export default "__VITE_ASSET__C8tQF4qQ__"